import { TargetDetails } from '@/types/workspace';

export const INITIAL_TARGET_DETAILS: TargetDetails = {
  company: '',
  position: '',
  requirements: '',
  targetLocation: '',
  jobType: '',
  workModel: '',
  visaSponsorship: 'Unknown',
  visaSponsorshipLink: '',
  salaryRange: '',
};
